import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { oesAdvantages } from "../oesModulesData";

const OesAdvantagesSection: React.FC = () => (
  <section className="wdev-process" aria-labelledby="oes-advantages-title">
    <div className="container">
      <AnimatedSection className="wdev-section-head wdev-section-head--center">
        <h2
          id="oes-advantages-title"
          className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
        >
          Platform Advantages
        </h2>
        <p className="oes-section-lead oes-section-lead--dark">
          A secure, scalable examination system built for schools, colleges, universities, and coaching institutes.
        </p>
      </AnimatedSection>

      <div className="oes-advantages-grid">
        {oesAdvantages.map((advantage, index) => (
          <motion.div
            key={advantage}
            className="wdev-process__card oes-advantage-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: index * 0.05 }}
            whileHover={{ y: -4, transition: { duration: 0.25 } }}
          >
            <p className="oes-advantage-card__text">{advantage}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default OesAdvantagesSection;
